import * as appHelper from './appHelper';
import * as localStorage from '../localStorage/localStorage';
import _ from 'lodash';

export function getTotalAchievedCount(badges){
	let achieved = 0;
	for(let i  = 0 ; i < badges.length; i++){
		let  badge = badges[i];
		achieved = achieved + badge.achieved;
	}
	return achieved;
}

export function biteHasvisibleBadges(bite) {
    let visibleBadges = 0;

    if (appHelper.isDefined(bite.badges)) {
        _.forEach(bite.badges, function (badge) {
            if (!appHelper.isDefined(badge.is_visible) || (appHelper.isDefined(badge.is_visible) && badge.is_visible)) {
                visibleBadges++;
            }
        });
    }

    return visibleBadges > 0;
}

export function getBadgeParentBiteId(badge_id) {
    let bite_id =  -1;
    for (let i = 0; i < localStorage.bites.length; i++) {
        let bite = localStorage.bites[i];
        if(appHelper.isDefined(bite.badges)){
            let badgeIndex = appHelper.getArrayObjectIndexByKey(bite.badges,"badge_id",badge_id);
            if(badgeIndex > -1){
                bite_id = bite.bite_id;
                break;
            }
        }
    }
    return bite_id;
}


/** WEBPACK FOOTER **
 ** ./src/helpers/badgeHelper.js
 **/